import { Client } from './client';
import { SessionData } from './initializer';
import logger from './logger';
import throttler from './throttler';
import { noWindow } from './noWindow';

export type WtaCmdCb = (client: Client) => any;

export type WtaCmdCbExecutor = (fn: WtaCmdCb) => void;

export type WtaCmd = {
    push: WtaCmdCbExecutor;
    forEach: (fn: WtaCmdCbExecutor) => any;
}

declare global {
    export interface Window {
        wtaCmd: WtaCmd;
    }
}

export type WtaState = Pick<SessionData, 'authState' | 'subscriptionStatus'>;

// Send the API into the global scope, for external usage:
export default (client: Client) => {

    // Account for server-side render:
    // tslint:disable-next-line: strict-type-predicates
    if (noWindow()) {
        return
    }

    // Set up global command queue, and execute any events that had already amassed:
    const cmdExecute = (fn: WtaCmdCb): void => {
        try {
            fn(client);
        } catch (e) {
            logger.error(e);
        }
    };
    window.wtaCmd = window.wtaCmd || [];
    window.wtaCmd.forEach(cmdExecute);
    (window.wtaCmd).push = cmdExecute;

    // Send all unsent cached events as user leaves page:
    window.addEventListener('beforeunload', throttler.sendCachedEvents);
};
